import { Navigate } from 'react-router-dom'

/** Legacy route — inbox lives under /account/notifikationer/indbakke. */
const NotificationsPage: React.FC = () => (
  <Navigate to="/account/notifikationer/indbakke" replace />
)

export default NotificationsPage
